import axios from 'axios';

const api = axios.create({
  // baseURL: 'https://apiv2.off-let.com',
  // baseURL: 'https://developers.off-let.com',
  baseURL: 'http://localhost:3333',
});
export default api;
